import { Module } from 'vuex'

import { GetOpenReviewPostEntryListUseCase } from '@/application/reviewPost/getOpenReviewPostEntryListUseCase'
import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewPostRepository } from '@/domain/repositories/reviewPost/reviewPostRepository'

interface ReviewPostEntryState {
  entryList: ReviewEntry[]
  isLoading: boolean
  error: Error | null
}

export const openReviewPostEntryModule = (repository: ReviewPostRepository): Module<ReviewPostEntryState, any> => {
  const getOpenReviewPostEntryListUseCase = new GetOpenReviewPostEntryListUseCase(repository)

  return {
    namespaced: true,
    state: {
      entryList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setEntryList(state, entryList: ReviewEntry[]) {
        state.entryList = entryList
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchReviewEntryList({ state, commit }, { problemId }: { problemId: string }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const entryList = await getOpenReviewPostEntryListUseCase.getByProblemIdOpenEntries(problemId)
          commit('setEntryList', entryList)
        } catch (e) {
          commit('setError', e)
          commit('setEntryList', [])
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      entryList: state => state.entryList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
